/**
 * Store Locations Constants for TuTiMi Application
 * Contains all store location data including addresses, contact info, and operating hours
 */

export interface StoreLocation {
  id: number
  name: string
  address: string
  phone: string
  hours: string
}

export interface StoreLocationsByArea {
  [area: string]: StoreLocation[]
}

/**
 * Store Locations Grouped by District/Area
 * Organized for interactive area selection in Footer component
 * Updated with actual TuTiMi store data
 */
export const STORE_LOCATIONS_BY_AREA: StoreLocationsByArea = {
  "Quận 1": [
    {
      id: 1,
      name: "Lê Thị Riêng",
      address: "60h Lê Thị Riêng, P. Bến Thành, Quận 1, Thành phố Hồ Chí Minh",
      phone: "0901837854",
      hours: "6h-23h",
    },
  ],
  "Quận 3": [
    {
      id: 2,
      name: "Cách Mạng Tháng Tám",
      address:
        "376d Cách Mạng Tháng Tám, Phường 10, Quận 3, Thành phố Hồ Chí Minh",
      phone: "0589855660",
      hours: "6h-23h",
    },
  ],
  "Quận 4": [
    {
      id: 3,
      name: "Vĩnh Hội",
      address: "98 Vĩnh Hội, Phường 4, Quận 4, Thành phố Hồ Chí Minh",
      phone: "0909471528",
      hours: "6h-23h",
    },
  ],
  "Quận 7": [
    {
      id: 4,
      name: "Tân Kiểng",
      address:
        "26 Đường Số 17, Phường Tân Kiểng, Quận 7, Thành phố Hồ Chí Minh",
      phone: "0582979262",
      hours: "6h-23h",
    },
  ],
  "Quận 8": [
    {
      id: 5,
      name: "Đặng Chất",
      address: "45 Đặng Chất, Phường 2, Quận 8, Thành phố Hồ Chí Minh",
      phone: "0924895328",
      hours: "6h-23h",
    },
  ],
  "Quận 10": [
    {
      id: 6,
      name: "Nguyễn Tri Phương",
      address: "372 Nguyễn Tri Phương Phường 4, Quận 10, Thành phố Hồ Chí Minh",
      phone: "0933387161",
      hours: "6h-23h",
    },
  ],
  "Quận 12": [
    {
      id: 7,
      name: "Nguyễn Văn Quá",
      address:
        "966 Đường Nguyễn Văn Quá, Đông Hưng Thuận, Quận 12, Thành phố Hồ Chí Minh",
      phone: "0584984031",
      hours: "6h-23h",
    },
    {
      id: 8,
      name: "71A Nguyễn Văn Quá",
      address:
        "71a Nguyễn Văn Quá, Phường Tân Hưng Thuận, Quận 12, Thành phố Hồ Chí Minh",
      phone: "0584793279",
      hours: "6h-23h",
    },
  ],
  "Bình Thạnh": [
    {
      id: 10,
      name: "Bình Quới",
      address:
        "129a Bình Quới, Phường 27, Quận Bình Thạnh, Thành phố Hồ Chí Minh",
      phone: "0562628240",
      hours: "6h-23h",
    },
    {
      id: 11,
      name: "Đinh Bộ Lĩnh",
      address:
        "141 Đinh Bộ Lĩnh, Phường 26, Quận Bình Thạnh, Thành phố Hồ Chí Minh",
      phone: "0909462558",
      hours: "6h-23h",
    },
    {
      id: 12,
      name: "Ngô Tất Tố",
      address:
        "71 Ngô Tất Tố, Phường 21, Quận Bình Thạnh, Thành phố Hồ Chí Minh",
      phone: "0909472958",
      hours: "6h-23h",
    },
    {
      id: 13,
      name: "Vạn Kiếp",
      address: "97a Vạn Kiếp, Phường 3, Quận Bình Thạnh, Thành phố Hồ Chí Minh",
      phone: "0909987418",
      hours: "6h-23h",
    },
    {
      id: 14,
      name: "Đặng Thuỳ Trâm",
      address:
        "39/50 Đặng Thuỳ Trâm, Phường 13, Quận Bình Thạnh, Thành phố Hồ Chí Minh",
      phone: "0563247332",
      hours: "6h-23h",
    },
  ],
  "Tân Bình": [
    {
      id: 15,
      name: "Đồng Đen",
      address: "39 Đồng Đen, Phường 12, Quận Tân Bình, Thành phố Hồ Chí Minh",
      phone: "0707528559",
      hours: "6h-23h",
    },
    {
      id: 16,
      name: "Lạc Long Quân",
      address:
        "712 Lạc Long Quân, Phường 9, Quận Tân Bình, Thành phố Hồ Chí Minh",
      phone: "0762980137",
      hours: "6h-23h",
    },
    {
      id: 17,
      name: "Trường Sơn",
      address: "65 Trường Sơn, Phường 2, Quận Tân Bình, Thành phố Hồ Chí Minh",
      phone: "0909144618",
      hours: "6h-23h",
    },
  ],
  "Gò Vấp": [
    {
      id: 18,
      name: "Đường số 8",
      address: "202 Đường Số 8, Phường 11, Quận Gò Vấp, Thành phố Hồ Chí Minh",
      phone: "0764282047",
      hours: "6h-23h",
    },
    {
      id: 19,
      name: "Phan Văn Trị",
      address: "711 Phan Văn Trị, Phường 7, Quận Gò Vấp, Thành phố Hồ Chí Minh",
      phone: "0909814958",
      hours: "6h-23h",
    },
  ],
  "Phú Nhuận": [
    {
      id: 20,
      name: "Nguyễn Kiệm",
      address:
        "376 Nguyễn Kiệm, Phường 3, Quận Phú Nhuận, Thành phố Hồ Chí Minh",
      phone: "0909815428",
      hours: "6h-23h",
    },
  ],
  "Tân Phú": [
    {
      id: 21,
      name: "Tân Quý",
      address:
        "34c Tân Quý, Phường Tân Quý, Quận Tân Phú, Thành phố Hồ Chí Minh",
      phone: "0395850994",
      hours: "6h-23h",
    },
  ],
  "Bình Tân": [
    {
      id: 22,
      name: "Tỉnh Lộ 10",
      address:
        "329 Tỉnh Lộ 10, P. An Lạc, Quận Bình Tân, Thành phố Hồ Chí Minh",
      phone: "0589855674",
      hours: "6h-23h",
    },
    {
      id: 23,
      name: "Lê Văn Quới",
      address:
        "572 Lê Văn Quới, Phường Bình Hưng Hòa A, Quận Bình Tân, Thành phố Hồ Chí Minh",
      phone: "0395903141",
      hours: "6h-23h",
    },
    {
      id: 24,
      name: "Hồ Học Lãm",
      address:
        "486A Hồ Học Lãm, phường An Lạc, Quận Bình Tân, Thành phố Hồ Chí Minh",
      phone: "0909462558",
      hours: "6h-23h",
    },
  ],
  "Thủ Đức": [
    {
      id: 25,
      name: "Hiệp Bình",
      address:
        "77a Hiệp Bình Phường Hiệp Bình Phước, Thành Phố Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0909986594",
      hours: "6h-23h",
    },
    {
      id: 26,
      name: "Nguyễn Duy Trinh",
      address:
        "168a Nguyễn Duy Trinh, Phường Bình Trưng Tây, Thành Phố Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0563245841",
      hours: "6h-23h",
    },
    {
      id: 27,
      name: "Đường Số 17, Thủ Đức",
      address:
        "38a Đường Số 17, Phường Linh Chiểu, Thành Phố Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0795561505",
      hours: "6h-23h",
    },
    {
      id: 28,
      name: "Đỗ Xuân Hợp",
      address:
        "275 Đỗ Xuân Hợp, Phường Phước Long B, Thành Phố Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0587699857",
      hours: "6h-23h",
    },
    {
      id: 29,
      name: "Đường Số 3",
      address:
        "59 Đường Số 3, Phường An Khánh, Thành Phố Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0333176264",
      hours: "6h-23h",
    },
    {
      id: 30,
      name: "Man Thiện",
      address:
        "45 Man Thiện Phường Tân Hiệp Phú, Thành Phố Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0773821294",
      hours: "6h-23h",
    },
  ],
  "Hóc Môn": [
    {
      id: 31,
      name: "Quang Trung",
      address:
        "129 Quang Trung, Thị Trấn Hóc Môn, Huyện Hóc Môn, Thành phố Hồ Chí Minh",
      phone: "0562732641",
      hours: "6h-23h",
    },
  ],
}
